import {bootstrapApplication} from '@angular/platform-browser';
import {importProvidersFrom, isDevMode} from '@angular/core';
import {AppComponent} from './app/view-layer/components/app.component';
import {AppModule} from './app/app.module';
import {provideRouter} from '@angular/router';
import { routes } from './app/app-routing.module';
import '@angular/localize/init';
import { provideServiceWorker } from '@angular/service-worker';


setTimeout(() => {
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(AppModule),
      provideRouter(routes), provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          }), provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          }), provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          }), provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          })
    ]
  })
}, 0);
